import {MediumContentType, MediumContentTypeClass} from "../modules/system/modules/media_library/enums/MediumContents";
import {
  DeserializedRecord,
  deserializeItem,
  deserializeManyRelationship,
  Deserializer,
  deserializeSingleRelationship,
  JSONAPIManyRelationship,
  JSONAPIRecord,
  JSONAPISingleRelationship
} from "./Helpers";
import {Cohort, deserializeCohort} from "./Cohort";
import {UploadedFile} from "helpers/forms/fields/file_field/interfaces/UploadedFile";
import {MediumTag} from "../modules/system/modules/media_library/interfaces/MediumTag";
import {deserializeMediumExternalResource, MediumResource} from "./medium/MediumResource";
import {MediumVideo} from "./medium/MediumVideo";
import {MediumPdf} from "./medium/MediumPdf";
import {MediumAudio} from "./medium/MediumAudio";

type MediumContent = MediumVideo | MediumPdf | MediumAudio | MediumResource;

interface Medium extends DeserializedRecord {
    name: string,
    tags: Cohort[]
    materialNo: string,
    description?: string,
    itemReference: string,
    content: MediumContent
    contentType: MediumContentType | MediumContentTypeClass,
    url: string,
    files: UploadedFile[],
    tagAssignments: MediumTag[],
    externalResourceName: string,
    externalResourceIdentifier: string,
    deletedAt?: Date,
}

interface MediumData extends JSONAPIRecord {
  relationships: {
    tags: JSONAPIManyRelationship;
    medium_tags: JSONAPIManyRelationship;
    content: JSONAPISingleRelationship
  }
}

interface MediumTagData extends JSONAPIRecord {
  relationships: {
    tag: JSONAPISingleRelationship
  }
}

const deserializeMediumTag: Deserializer<MediumTag, MediumTagData> = (data, included) => ({
  ...deserializeItem(data),
  tagId: data.relationships.tag.data.id,
  tag: deserializeSingleRelationship<Cohort>(data.relationships.tag, included)
});

const deserializerByContentType = (contentType: string) => {
  switch (contentType) {
    case 'medium_external_resource':
      return deserializeMediumExternalResource;
    default:
      return deserializeItem;
  }
};

const deserializeMedium: Deserializer<Medium, MediumData> = (data, included) => {
  const cohorts = deserializeManyRelationship<Cohort>(data.relationships.tags, included, deserializeCohort);
  const cohortAssignments = deserializeManyRelationship<MediumTag>(data.relationships.medium_tags, included, deserializeMediumTag);

  const content = deserializeSingleRelationship<MediumContent>(
    data.relationships.content,
    included,
    deserializerByContentType(data.relationships.content.data.type)
  );

  return {
    ...deserializeItem<Medium>(data),
    tags: cohorts,
    tagAssignments: cohortAssignments,
    content: content
  };
};

export {
  Medium, deserializeMedium, MediumContent
};
